import type { ActivityModule } from '../../core/activity';
import { mountScalesboard } from './ui';
import levelsData from './levels.json';
import './style.css';

export const scalesboard: ActivityModule = {
  id: 'scalesboard',
  title: 'Balança',
  description: 'Coloque os pesos pra equilibrar a balança. Em níveis avançados, você usa os dois lados.',
  ageMin: 7,
  ageMax: 11,
  difficulty: 2,
  iconPath: 'assets/gcompris-AGPL/scalesboard/icon.svg',
  category: 'aritmetica',
  totalLevels: levelsData.levels.length,
  mount: mountScalesboard,
};
